import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY?.trim(),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN?.trim(),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID?.trim(),
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET?.trim(),
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID?.trim(),
  appId: process.env.REACT_APP_FIREBASE_APP_ID?.trim(),
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID?.trim()
};

// Initialize Firebase only if config is provided
let app;
let analytics;
let analyticsUser = JSON.parse(
  localStorage.getItem('analyticsUser') || '{}'
);

try {
  if (firebaseConfig.projectId) {
    app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
    console.log('Firebase Analytics initialized successfully');
  } else {
    console.warn('Firebase configuration is missing. Analytics not initialized.');
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export const setAnalyticsUser = (user) => {
  analyticsUser = {
    doctorId: String(user.doctorId || ''),
    doctorName: user.doctorName || '',
    hospitalId: String(user.hospitalId || ''),
    hospitalName: user.hospitalName || '',
    role: user.role || '',
  };
};

const trackEvent = (eventName, eventParams = {}) => {
  if (!analytics) return;

  logEvent(analytics, eventName, {
    ...analyticsUser,
    ...eventParams,
  });
};

export { app, analytics, trackEvent };